<template>
  <CustomDialog
    :visible="visible"
    :modalClass="modalClass"
    :closable="closable"
    @update:visible="updateVisible"
  >
    <template #header>
      <div class="inline-flex items-center justify-center gap-2">
        <font-awesome-icon
          :icon="icon"
          class="text-[24px] font-extrabold leading-6 text-center"
          :class="iconColor"
        />
        <span
          class="ml-2 font-600 whitespace-nowrap text-[20px] leading-24 tracking-[-0.2px] dark:text-text-primary-dark"
        >
          {{ header }}
        </span>
      </div>
    </template>

    <!-- Descripción -->
    <template #description>
      <span
        class="text-text-secondary font-400 text-[14px] leading-5 tracking-[-0.4px] dark:text-dark-secondary"
      >
        {{ description }}
      </span>
    </template>

    <!-- Contenido dinámico -->
    <template #content>
      <div v-if="data && !fileList">
        <div
          v-for="(item, index) in data"
          :key="index"
          class="flex justify-start mb-1"
        >
          <p
            class="w-4/12 text-text-secondary font-600 text-[14px] leading-6 dark:text-dark-secondary"
          >
            {{ item.text }}
          </p>
          <span
            class="w-6/12 text-text-secondary font-400 text-[14px] leading-6 tracking-[-0.4px] dark:text-dark-secondary"
          >
            {{ item.value || "No especificado" }}
          </span>
        </div>
      </div>
    </template>

    <!-- Botones -->
    <template #footer>
      <div
        class="flex"
        :class="{
          'justify-between': buttonType?.length === 2,
          'justify-center':
            buttonType?.length === 1 && buttonType[0] === 'Cancelar',
          'justify-end':
            buttonType?.length === 1 && buttonType[0] === 'Aceptar',
        }"
      >
        <CustomButton
          v-for="(button, index) in buttonType"
          :key="index"
          :label="button"
          :text="button === 'Cancelar'"
          :variant="button === 'Cancelar' ? 'link' : 'primary'"
          :class="[
            'font-700 leading-4 tracking-[-0.2px]',
            button === 'Cancelar' ? 'text-[14px]! w-21.75 h-10' : '',
            button === 'Aceptar' ? 'text-[12px]! w-20.25 h-10' : '',
          ]"
          @click="button === 'Cancelar' ? cancel() : finallyStep()"
        />
      </div>
    </template>
  </CustomDialog>
</template>

<script setup lang="ts">
import CustomButton from "./CustomButton.vue";

const props = defineProps({
  visible: Boolean,
  data: Object,
  header: String,
  fileList: Boolean,
  description: String,
  icon: String,
  iconColor: String,
  borderModal: String,
  modalClass: String,
  buttonType: {
    type: Array as () => string[],
    default: () => [],
  },
  closable: Boolean,
  realoadPage: { type: Boolean, default: true },
});

const emit = defineEmits(["update:visible", "onAccept"]);
const updateVisible = (value: boolean) => {
  emit("update:visible", value);
};

const cancel = () => {
  updateVisible(false);
};

const finallyStep = () => {
  if (props.realoadPage) {
    window.location.reload();
  } else {
    emit("onAccept");
  }
};
</script>

<style scoped>
.align-items-center {
  align-items: start;
}
</style>
